<template>
  <div class="main-cn">
    <el-row class="searchSection">
      <el-form ref="form" :inline="true" :model="searcheModel">
        <el-form-item label="所属部门">
          <UserCascader
            v-model="searcheModel.branch_id"
            ref="branch"
            :isBusiness="true"
            @change="changeBranch"
          ></UserCascader>
        </el-form-item>
        <el-form-item label="业务员">
          <UserSelect
            ref="user"
            @change="salesmanHandleChange"
          ></UserSelect>
        </el-form-item>
        <el-form-item label="解绑时间">
          <el-date-picker
            size="small"
            v-model="searcheModel.created_at"
            type="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="解绑类型">
          <el-select size="small" v-model="searcheModel.unbind_type" placeholder="请选择">
            <el-option label="不限" value=""></el-option>
            <el-option label="自动解绑" value="1"></el-option>
            <el-option label="手动解绑" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="来源" prop="source">
          <ChannelCascader ref="channelCascader" :channel="channel" @change="channelHandleChange"></ChannelCascader>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="submitSearch"
            >搜索</el-button
          >
          <el-button @click="resetForm()" size="small">重置</el-button>
          <ExportFile 
          v-if="Acs('/export/sales-' + active_name)"
          :url="'/api/export/sales-' + active_name" 
          :params="searcheModel" 
          filename="线索解绑统计数据表" 
          buttonName="导出Excel">
          </ExportFile>
        </el-form-item>
      </el-form>
    </el-row>
    <div class="main-bd mg20 pro-visible" v-loading="loading">
      <el-row :gutter="10" class="searchSection">
        <el-col :span="6">
          <div>
            <label class="item-title">线索解绑分析</label>
          </div>
        </el-col>
      </el-row>
      <div ref="clueUnbindChart" :style="{ height: '400px', width: '100%' }" :key="clue_unbind_chart_key"></div>
    </div>
    <div class="main-bd mg20 pro-visible" v-loading="loading">
      <el-row :gutter="10" class="searchSection">
        <el-col :span="6">
          <div>
            <label class="item-title">线索解绑总体情况</label>
          </div>
        </el-col>
      </el-row>
      <el-table 
      v-if="!loading"
      :data="list" 
      border 
      height="500"
      row-key="id" 
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}" 
      :header-cell-style="{background: '#f3faff'}"
      :summary-method="getSummaries" 
      show-summary>
        <el-table-column prop="name" label="部门        |         业务员" width="220"></el-table-column>
        <el-table-column prop="count_num" label="解绑线索数"></el-table-column>
        <el-table-column prop="student_num" label="学生或家长、非学校职工"></el-table-column>
        <el-table-column prop="bad_number_num" label="空号、关机、无法接通或号码无效"></el-table-column>
        <el-table-column prop="rejected_num" label="多次挂断或多次拒接"></el-table-column>
        <el-table-column prop="not_apply_num" label="不是申请人"></el-table-column>
        <el-table-column prop="competitor_num" label="竞品公司"></el-table-column>
        <el-table-column prop="info_incorrect_num" label="学校名称，申请人信息不正确"></el-table-column>
        <el-table-column prop="other_num" label="其他"></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<style scoped>
</style>
<script>
import ClueCount from "~/services/ClueCount";
import UserCascader from "~/widgets/UserCascader.vue";
import UserSelect from "~/widgets/UserSelect.vue";
import ChannelCascader from "~/widgets/ChannelCascader.vue";
import ExportFile from "~/widgets/ExportFile.vue";
import Config from "~/config/params";
import echarts from 'echarts';

export default {
  name: "clueUnbind",

  components: {
    UserSelect,
    UserCascader,
    ExportFile,
    ChannelCascader
  },

  props: {},

  data() {
    return {
      loading: false,
      searcheModel: {
        branch_id: "",
        user_id: "",
        created_at: Config.getDataTimes('this_week'),
        unbind_type: '',
        source: '',
      },
      channel: {
        pid: 0,
        id: 0,
      },
      list: [],
      params: {},
      labels: [],
      count_list: [],
      active_name: 'unbind-list',
      clue_unbind_chart_key: 0,
    };
  },

  mounted() {
    
  },

  created: function () {
    this.resetForm();
  },

  methods: {

    //重置按钮
    resetForm() {
      this.searcheModel = {
        branch_id: "",
        user_id: "",
        created_at: Config.getDataTimes('this_week'),
        unbind_type: '',
        source: '',
      };
      if(this.$refs['branch']){
        this.$refs['branch'].reset();
      }
      if(this.$refs['user']){
        this.$refs['user'].reset();
      }
      if(this.$refs['channelCascader']){
        this.$refs['channelCascader'].reset();
      }
      this.list = [];
      this.submitSearch();
    },

    // 筛选查询
    submitSearch() {
      this.clue_unbind_chart_key ++;
      this.getList(this.searcheModel);
      this.getCount(this.searcheModel);
    },

    //获取列表
    getList(params) {
      // loading 动画
      this.loading = true;
      this.list = [];
      ClueCount.getList(params, this.active_name)
        .then((res) => {
            if (res.code == 0) {
                this.list = res.data;
            }
            this.loading = false;
        })
        .catch((err) => {
          console.error(err);
          this.loading = false;
        });
    },

    //切换部门子组件
    changeBranch(value) {
      if (value.length > 0) {
        // 取得最后一级部门作为所属部门
        this.searcheModel.branch_id = value[value.length - 1];
      } else {
        this.searcheModel.branch_id = "";
      }
    },

    //切换业务员子组件
    salesmanHandleChange(object) {
      this.searcheModel.user_id = object.label;
    },

    //切换运营渠道子组件
    channelHandleChange(value) {
      // console.log("运营渠道：", value);
      if (value && value.length > 0) {
        this.searcheModel.source = value[value.length - 1].toString();
        this.channel = {
          pid: value.length == 2 ? value[0] : 0,
          id: value[value.length - 1],
        };
      } else {
        this.searcheModel.source = "";
        this.channel = _.clone(
          _.extend(this.searcheModel, {
            pid: "",
            id: "",
          })
        );
      }
    },

    getCount(params) {
      this.loading = true;
      this.count_list = [];
      this.labels = [];
      ClueCount.getList(params, 'unbind-chart')
      .then((res) => {
        // console.log('统计：', res.code == 0 && res.data.hasOwnProperty('labels') && res.data.labels.length > 0);
        if (res.code == 0 && res.data.hasOwnProperty('labels') && res.data.labels.length > 0) {
          //初始化地图
          this.count_list = res.data.list;
          this.labels = res.data.labels;
          this.initChart();
        }
        this.loading = false;
      })
      .catch((err) => {
          console.error(err);
          this.loading = false;
      });
    },

    initChart() {
      if(this.count_list.length == 0 || this.labels.length == 0){
          return false;
      }
      const chartContainer = this.$refs.clueUnbindChart;
      if (!chartContainer){
          return false;
      }
      const myChart = echarts.init(chartContainer);
      let option = {
        color: [
            '#5470c6',
            "#91cc75",
            "#fac858",
            "#ee6666",
            "#73c0de",
            "#3dac78",
            '#C280FF',
            '#34B7FB',
            '#81D3F8',
            '#95F204',
            '#F56C6C',
            '#04D919',
            '#FFA680',
            '#B1DDF5',
            '#CBE7F4',
            '#D2F2A0',
            '#F3C4C4',
            '#A0E9A8',
            '#F6D8CB',
            '#8080FF',
            '#FF4D00',
        ],
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            }
        },
        legend: {},
        grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        xAxis: [
            {
                type: 'category',
                data: this.labels,
                // axisLabel:{
                //     interval:0, //控制X轴刻度全部显示
                //     rotate:45 //倾斜角度
                // }
            }
        ],
        yAxis: [
            {
                type: 'value'
            }
        ],
        toolbox: {
            show: true,
            orient: 'vertical',
            left: 'right',
            top: 'center',
            feature: {
                mark: {show: true},
                dataView: {show: true, readOnly: false},
                magicType: {show: true, type: ['line', 'bar', 'tiled']},
                restore: {show: true},
                saveAsImage: {show: true}
            }
        },
        series: []
      };
      this.count_list.forEach(item => {
        const nonZeroData = Object.values(item.children).some(value => value !== 0);
        if(nonZeroData){
          option.series.push(
              {
                  name: item.name,
                  type: 'bar',
                  emphasis: {
                      focus: 'series'
                  },
                  data: Object.values(item.children)//.map(value => value === 0 ? null : value)
              },
          );
        }
      });
      // console.log('初始化图表：', this.count_list, option);
      myChart.setOption(option);
      
    },


    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        // 第一列不计算合计，显示自定义的文字内容
        if (index === 0) {
          sums.push('合计：');
          return;
        }
        // 初始化合计值为0
        let sum = 0;
        // 遍历数据，累加顶级行的值
        data.forEach(item => {
          // 累加当前项的值，注意转换为数字
          sum += Number(item[column.property]);
        });
        // 如果所有值都是数字，则显示合计结果，否则显示'-'
        if (!isNaN(sum)) {
          sums.push(Math.round(sum * 100) / 100); // 保留两位小数
        } else {
          sums.push('--');
        }
      });
      return sums;
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/views/count/clue/unbind.vue